/**
 * NeuroMD Restore PDP.
 *
 * Controllers cover the gallery, offer ladder, cart, carousels, timeline and lightbox. All prices shown
 * are rendered by Liquid -- this script only moves existing strings around, so
 * it can never disagree with the store's currency settings.
 */
(function () {
  'use strict';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function cartAddUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/add.js';
  }

  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var stage = main && main.closest('.rs-gallery__stage');
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = toArray(root.querySelectorAll('[data-gallery-src]'));
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (!main || !thumbs.length) return;

    function activate(button) {
      if (!button) return;
      main.src = button.dataset.gallerySrc;
      main.alt = button.dataset.galleryAlt || '';
      thumbs.forEach(function (thumb) {
        var on = thumb === button;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activate(thumb); });
    });

    /** Scroll the strip by roughly one viewport of thumbnails. */
    function nudge(direction) {
      if (!track) return;
      track.scrollBy({ left: direction * Math.max(track.clientWidth - 96, 96), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    function syncArrows() {
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    if (track) {
      track.addEventListener('scroll', syncArrows);
      window.addEventListener('resize', syncArrows);
      syncArrows();
    }

    if (stage && thumbs.length > 1) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swiping = false;

      stage.addEventListener('pointerdown', function (event) {
        swiping = true;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        stage.setPointerCapture(event.pointerId);
      });
      stage.addEventListener('pointerup', function (event) {
        if (!swiping) return;
        swiping = false;
        var dx = event.clientX - swipeStartX;
        var dy = event.clientY - swipeStartY;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        var current = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); }));
        var nextIndex = dx < 0 ? Math.min(current + 1, thumbs.length - 1) : Math.max(current - 1, 0);
        activate(thumbs[nextIndex]);
      });
      stage.addEventListener('pointercancel', function () { swiping = false; });
    }
  }

  /**
   * Offer ladder + subscription.
   *
   * Every offer is a dedicated Shopify variant and is paired with its matching
   * delivery frequency. Quantity stays at one bundle variant per cart line.
   */
  function initOffer(root) {
    var tiers = toArray(root.querySelectorAll('[data-tier]'));
    var idInput = root.querySelector('[data-variant-id]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var planInput = root.querySelector('[data-selling-plan-input]');
    var subRow = root.querySelector('[data-subscribe-row]');
    var subToggle = root.querySelector('[data-subscribe-toggle]');
    var subNote = root.querySelector('[data-subscribe-note]');
    var subTitle = root.querySelector('[data-subscribe-title]');
    var subFrequency = root.querySelector('[data-subscribe-frequency]');
    var buyPriceNow = root.querySelector('[data-buy-price-now]');
    var buyPriceWas = root.querySelector('[data-buy-price-was]');

    if (!tiers.length && !subToggle) return;

    function selected() {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].checked) return tiers[i];
      }
      return tiers[0] || null;
    }

    function sync() {
      var tier = selected();
      var subscribable = !tier || tier.dataset.tierSubscribable === 'true';
      var subscribing = Boolean(subToggle && subToggle.checked && subscribable);

      tiers.forEach(function (input) {
        var card = input.closest('.rs-tier');
        if (card) {
          card.classList.toggle('is-selected', input.checked);
          var cardPrice = card.querySelector('.rs-tier__price');
          var cardEach = card.querySelector('[data-tier-each]');
          var cardWas = card.querySelector('.rs-tier__was');
          var cardSubscribable = input.dataset.tierSubscribable === 'true';
          var showSubscriptionPrice = Boolean(subToggle && subToggle.checked && cardSubscribable);
          var currentPrice = showSubscriptionPrice
            ? input.dataset.tierSubscribePrice
            : input.dataset.tierOneTimePrice;
          var previousPrice = showSubscriptionPrice
            ? input.dataset.tierOneTimePrice
            : input.dataset.tierComparePrice;

          if (cardPrice && currentPrice) cardPrice.textContent = currentPrice;
          var currentEach = showSubscriptionPrice
            ? input.dataset.tierSubscribeEach
            : input.dataset.tierOneTimeEach;
          if (cardEach && currentEach) cardEach.textContent = currentEach;
          if (cardWas) {
            cardWas.textContent = previousPrice || '';
            cardWas.hidden = !previousPrice || previousPrice === currentPrice;
          }
        }
      });

      if (tier && quantityInput) quantityInput.value = tier.dataset.tierQuantity || '1';
      if (tier && idInput) idInput.value = tier.dataset.tierVariantId || tier.value;

      if (subRow) {
        subRow.classList.toggle('is-disabled', !subscribable);
        if (subToggle) {
          subToggle.disabled = !subscribable;
          subToggle.value = tier ? (tier.dataset.tierSellingPlanId || '') : '';
        }
        if (subNote) subNote.hidden = subscribable;
      }

      if (tier && subTitle) {
        var percent = Number(tier.dataset.tierSubscribePercent || 0);
        subTitle.textContent = percent > 0
          ? 'Save ' + percent + '% with automatic refills'
          : 'Save with automatic refills';
      }
      if (tier && subFrequency) {
        subFrequency.textContent = tier.dataset.tierPlanName || 'Automatic delivery';
      }

      if (planInput) {
        planInput.disabled = !subscribing;
        planInput.value = subscribing && subToggle ? subToggle.value : '';
      }

      if (tier && buyPriceNow) {
        buyPriceNow.textContent = subscribing
          ? tier.dataset.tierSubscribePrice
          : tier.dataset.tierOneTimePrice;
      }
      if (tier && buyPriceWas) {
        var buyWas = subscribing ? tier.dataset.tierOneTimePrice : tier.dataset.tierComparePrice;
        buyPriceWas.textContent = buyWas || '';
        buyPriceWas.hidden = !buyWas;
      }

    }

    tiers.forEach(function (input) { input.addEventListener('change', sync); });
    if (subToggle) subToggle.addEventListener('change', sync);
    sync();
  }

  /**
   * Countdown. Counts to the exact end time the merchant entered, so it runs
   * out when the promotion actually does -- it never restarts on reload, which
   * is what makes the pattern on most stores dishonest. Hidden entirely once
   * the moment passes, and hidden if the date will not parse.
   */
  function initCountdown(root) {
    var el = root.querySelector('[data-countdown]');
    if (!el) return;
    var target = Date.parse(el.dataset.countdown);
    var out = el.querySelector('[data-countdown-value]');
    if (isNaN(target) || !out) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var remaining = target - Date.now();
      if (remaining <= 0) {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      out.textContent = pad(hours) + ':' + pad(Math.floor(totalSeconds / 60) % 60) + ':' + pad(totalSeconds % 60);
      out.setAttribute('datetime', el.dataset.countdown);
      el.hidden = false;
    }

    var timer = setInterval(tick, 1000);
    tick();
  }

  function initCart(root) {
    var form = root.querySelector('[data-restore-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var status = root.querySelector('[data-form-status]');
    var submit = form && form.querySelector('button[type="submit"]');
    var label = root.querySelector('[data-add-label]');
    var pending = false;

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    function buildLine() {
      var quantityInput = root.querySelector('[data-quantity-input]');
      var planInput = root.querySelector('[data-selling-plan-input]');
      var line = {
        id: Number(idInput.value),
        quantity: Number(quantityInput && quantityInput.value) || 1
      };
      if (planInput && !planInput.disabled && planInput.value) {
        line.selling_plan = Number(planInput.value);
      }
      return line;
    }

    function addToCart() {
      if (pending || !idInput || !idInput.value) return;
      pending = true;

      var restore = [
        { node: label, text: label && label.textContent, button: submit }
      ];
      restore.forEach(function (entry) {
        if (entry.button) entry.button.disabled = true;
        if (entry.node) entry.node.textContent = 'Adding…';
      });
      setStatus('', false);

      fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [buildLine()] })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
            return data;
          });
        })
        .then(function () {
          restore.forEach(function (entry) { if (entry.node) entry.node.textContent = 'Added to cart'; });
          setStatus('Restore was added to your cart.', false);
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          setTimeout(function () {
            restore.forEach(function (entry) {
              if (entry.node) entry.node.textContent = entry.text || 'Add to cart';
              if (entry.button) entry.button.disabled = false;
            });
            pending = false;
          }, 1800);
        })
        .catch(function (error) {
          restore.forEach(function (entry) {
            if (entry.node) entry.node.textContent = entry.text || 'Add to cart';
            if (entry.button) entry.button.disabled = false;
          });
          setStatus(error.message, true);
          pending = false;
        });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart();
      });
    }
  }

  /**
   * Slow ingredient rail. Any deliberate interaction permanently disables
   * autoplay for this page view; native touch/trackpad/keyboard scrolling and
   * mouse dragging remain available afterward.
   */
  function initIngredientCarousel(root) {
    var carousel = root.querySelector('[data-ingredient-carousel]');
    var track = carousel && carousel.querySelector('[data-ingredient-track]');
    if (!track) return;

    var stopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var direction = 1;
    var last = 0;
    var frame = 0;
    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    function stopAutoplay() {
      if (stopped) return;
      stopped = true;
      carousel.classList.add('is-user-controlled');
      if (frame) cancelAnimationFrame(frame);
    }

    function step(time) {
      if (stopped) return;
      if (!last) last = time;
      var elapsed = Math.min(time - last, 40);
      last = time;
      var max = track.scrollWidth - track.clientWidth;
      if (max > 1) {
        track.scrollLeft += direction * elapsed * 0.012;
        if (track.scrollLeft >= max - 1) direction = -1;
        if (track.scrollLeft <= 1) direction = 1;
      }
      frame = requestAnimationFrame(step);
    }

    track.addEventListener('touchstart', stopAutoplay, { passive: true, once: true });
    track.addEventListener('wheel', stopAutoplay, { passive: true, once: true });
    track.addEventListener('keydown', stopAutoplay, { once: true });
    track.addEventListener('pointerdown', function (event) {
      stopAutoplay();
      if (event.pointerType === 'mouse') {
        dragging = true;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
    });
    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      event.preventDefault();
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });
    track.addEventListener('pointerup', function () {
      dragging = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('pointercancel', function () {
      dragging = false;
      track.classList.remove('is-dragging');
    });

    if (!stopped) frame = requestAnimationFrame(step);
  }

  function initReviewCarousel(root) {
    var carousel = root.querySelector('[data-review-carousel]');
    var track = carousel && carousel.querySelector('[data-review-track]');
    var prev = carousel && carousel.querySelector('[data-review-prev]');
    var next = carousel && carousel.querySelector('[data-review-next]');
    if (!track || !prev || !next) return;
    var dragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    function cardStep() {
      var card = track.querySelector('.rs-quote');
      var styles = card && window.getComputedStyle(track.querySelector('.rs-quotes__track'));
      return card ? card.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0) : track.clientWidth;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') return;
      dragging = true;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });
    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });
    track.addEventListener('pointerup', function () { dragging = false; });
    track.addEventListener('pointercancel', function () { dragging = false; });
    window.addEventListener('resize', sync);
    sync();
  }

  function initBenefitTimeline(root) {
    var timeline = root.querySelector('[data-benefit-timeline]');
    var rows = timeline && toArray(timeline.querySelectorAll('.rs-timeline__row'));
    var progress = timeline && timeline.querySelector('[data-timeline-progress]');
    if (!timeline || !rows.length || !('IntersectionObserver' in window)) return;

    timeline.classList.add('is-enhanced');

    function updateProgress() {
      var visibleCount = rows.filter(function (row) { return row.classList.contains('is-visible'); }).length;
      var percent = rows.length > 1 ? Math.max(0, (visibleCount - 1) / (rows.length - 1)) * 100 : 100;
      if (progress) progress.style.height = percent + '%';
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
      updateProgress();
    }, { threshold: 0.34, rootMargin: '0px 0px -12% 0px' });

    rows.forEach(function (row) { observer.observe(row); });
  }

  function initIngredientsLightbox(root) {
    var modal = root.querySelector('[data-ingredients-lightbox]');
    var triggers = toArray(root.querySelectorAll('[data-ingredients-lightbox-open]'));
    var close = modal && modal.querySelector('[data-ingredients-lightbox-close]');
    if (!modal || !triggers.length) return;
    var lastTrigger = null;

    function openModal(event) {
      lastTrigger = event.currentTarget;
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      document.documentElement.classList.add('rs-modal-open');
      if (close) close.focus();
    }

    function closeModal() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      document.documentElement.classList.remove('rs-modal-open');
      if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach(function (trigger) { trigger.addEventListener('click', openModal); });
    if (close) close.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
    modal.addEventListener('close', function () { document.documentElement.classList.remove('rs-modal-open'); });
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    initGallery(root);
    initOffer(root);
    initCountdown(root);
    initCart(root);
    initIngredientCarousel(root);
    initReviewCarousel(root);
    initBenefitTimeline(root);
    initIngredientsLightbox(root);
  }

  function boot() {
    toArray(document.querySelectorAll('.nmd-restore-pdp')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init after a theme-editor section reload.
  document.addEventListener('shopify:section:load', boot);
})();
